import { Component, OnInit } from '@angular/core';
import { QuoteDataCaptureService, LoaderService, SERVICE_END_POINT, AnalyticsService } from '../../../../../shared';
import { Router } from '@angular/router';
import * as UserDataConfig from '../../../../../common-components/config/user-data.config';
import { AlertModal } from '../../../../../model/alert';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../../store/state/app.state';
import { UtilService } from '../../../../../shared';
import * as loggedInDetailActions from '../../../../../store/actions/loggedin-detail.action';

@Component({
  selector: 'app-after-login',
  templateUrl: './after-login.component.html',
  styleUrls: ['./after-login.component.scss']
})
export class AfterLoginComponent implements OnInit {

  public displayAlert = true;
  public quoteRefNo;
  protected alertModalConfig: AlertModal;
  public loginResponse:any={};
  CMSData;
  constructor(private quoteDatacaptureService: QuoteDataCaptureService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private loaderService: LoaderService,
              private store: Store<AppState>,
              private utilService: UtilService,
              private analyticsService: AnalyticsService) {
      
    this.loaderService.handleSpinnerFlag({ show: true, onlyBackgroundFlag: false, Message: 'Loading...', opacity: 1 });
    this.alertModalConfig = this.activatedRoute.snapshot.data.contentData.LoginModalConfig;
    this.quoteRefNo = this.activatedRoute.snapshot.queryParamMap.get('quoteRefNo');
    
  }

  ngOnInit() {
    this.quoteDatacaptureService.postLoginCapture('', '', this.quoteRefNo).subscribe(res => {
      this.loginResponse=res;
      if (res.showWarning === 'Y') {
        this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: 1 });
        this.displayAlert = true;    
        this.GetCMSDataService();
      } else {
        this.store.dispatch(new loggedInDetailActions.RemoveLoggedInDetail(0));
        this.store.dispatch(new loggedInDetailActions.AddLoggedInDetail(res));
        const redirectUrl = this.getScreenName(res.currentScreen);
        const param = { url: redirectUrl };
        this.utilService.loadBreadcrumpAfterLogin(param);
        this.router.navigate([redirectUrl]);
        this.loaderService.handleSpinnerFlag({ show: false, onlyBackgroundFlag: false, Message: '', opacity: 1 });
      }
    }, error => this.displayAlert = false);
  }

  public getScreenName(currentscreen): string {
    const breadcrumbDetails = UserDataConfig.BreadcrumbConfig.data.values;
    return breadcrumbDetails.find(br => br.screenName === currentscreen).path;
  }

  alertPrimaryBtnClick() {
    this.analyticsService.eventTrack({
      type: 'ButtonClick',
      name: 'continue and use my registration details',
      pageID: this.utilService.getScreenNameFromURL(this.router.url)
    });
    this.displayAlert = false;
    this.quoteDatacaptureService.postLoginCapture('Y', 'EAPCAANDGCDMISMATCH', this.quoteRefNo).subscribe(res => {
      this.loginResponse=res;
      if (res.showWarning === 'Y') {
        this.displayAlert = true;

      } else {
        this.store.dispatch(new loggedInDetailActions.RemoveLoggedInDetail(0));
        this.store.dispatch(new loggedInDetailActions.AddLoggedInDetail(this.loginResponse));
        const redirectUrl = this.getScreenName(res.currentScreen);
        this.router.navigate([redirectUrl]);
      }
    }, error => this.displayAlert = false);

  }
  alertSecondaryBtnClick() {
    this.displayAlert = false;
  }
  closeModal() {
    //this.store.dispatch(new loggedInDetailActions.RemoveLoggedInDetail(0));
    if(this.quoteRefNo){
    
        this.quoteDatacaptureService.resumeQuote(this.quoteRefNo).subscribe(res => {
          // this.partialQuoteResultApi = res['partialQuotes'];
         // this.quote = res;
          //this.restoreAllStore(quoteRefNo, true, false);
          //console.log(res);
          this.utilService.restoreAllStore(this.quoteRefNo, true, false,res,null)
        });
    
      //resume  quoteneed to call
    }
    else{
      //go to first page
      this.router.navigate(['/home/get-your-online-quote']);
    }
    this.displayAlert = false;
  }
   /** CMS block  */
   GetCMSDataService() {
    //console.log('original value = ');
    const URL =  SERVICE_END_POINT.higherEnvironment.CMS_ShortModal_RegistrationDiffers;
    this.utilService.getCMSData(URL)
    .subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
      /** In the line below we are over-writing the contentData object values with CMSData object values */
        //console.log('changed value = ');
        }
    });
  }
  
  /** End of code block for CMS */

}
